import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { GbDashboardSharedUiModule } from '@galabid/gb-dashboard/shared/ui'
import {
  SiteAnnouncementsEntity,
  SiteAnnouncementsFacade,
} from '@galabid/gb-dashboard/staff/data-access-site-announcements'
import { TranslateModule } from '@ngx-translate/core'
import { BehaviorSubject, combineLatest, map, Observable, take, tap } from 'rxjs'
import { GbAnnouncementsCardComponentComponent } from '../gb-announcements-card/gb-announcements-card.component'
import { FilteredAnnouncementsService } from '../gb-announcements/gb-filtered-announcements.service'
import {
  GB_SEEN_ANNOUCEMENTS,
  GbLocalStorageService,
} from 'libs/gb-dashboard/shared/utils/src/lib/gb-localstorage-service/gb-localstorage.service'

@Component({
  selector: 'gb-announcements-list-dialog',
  templateUrl: './gb-announcements-list-dialog.component.html',
  styleUrls: ['./gb-announcements-list-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatButtonModule,
    MatDialogModule,
    GbDashboardSharedUiModule,
    GbAnnouncementsCardComponentComponent,
  ],
})
export class GbAnnouncementsListDialogComponent implements OnDestroy {
  announcementsLoaded$ = this.siteAnnouncementsFacade.loaded$
  displayIndex = 0
  displayIndexSubject$ = new BehaviorSubject<number>(this.displayIndex)

  unreadDialogAnnouncements$: Observable<SiteAnnouncementsEntity[]> =
    this.filteredAnnouncementsService.unreadDialogAnnouncements$

  displayAnnouncement$ = combineLatest([this.unreadDialogAnnouncements$, this.displayIndexSubject$]).pipe(
    map(([filteredAnnouncements, displayIndex]) => filteredAnnouncements[displayIndex]),
  )

  showFinalPage$: Observable<boolean> = combineLatest([
    this.unreadDialogAnnouncements$,
    this.displayIndexSubject$,
  ]).pipe(map(([unreadAnnouncements, displayIndexSubject]) => unreadAnnouncements.length - 1 === displayIndexSubject))

  constructor(
    private siteAnnouncementsFacade: SiteAnnouncementsFacade,
    private filteredAnnouncementsService: FilteredAnnouncementsService,
    private gbLocalStorageService: GbLocalStorageService,
  ) {}

  showNext() {
    this.displayIndex++
    this.displayIndexSubject$.next(this.displayIndex)
  }

  ngOnDestroy(): void {
    this.filteredAnnouncementsService.filteredAnnouncements$.pipe(take(1)).subscribe((announcements) => {
      const readStatusMap = this.filteredAnnouncementsService.getSiteAnnouncementsReadStatusMap()
      announcements.forEach((announcement) => {
        readStatusMap[announcement.uuid] = { ...(readStatusMap[announcement.uuid] || {}), dialog: true }
      })
      this.gbLocalStorageService.setItem(GB_SEEN_ANNOUCEMENTS, readStatusMap)
    })
  }
}
